import React, { useState, useEffect, useCallback, useContext } from "react";

import { useAlert } from "react-alert";
import { useDropzone } from "react-dropzone";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import { Button, Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import Switch from "@mui/material/Switch";
//import context from "../../../../../../context/auth-context";

import Docs from "./Docs/Docs.jsx";
import Locations from "./Locations/Locations";

function Results(props) {
  const [checked, setChecked] = useState(true);
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState(null);
  const alert = useAlert();

  const handleSubmit = async (file) => {
    if (file) {
      const apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6InNhIn0.eyJpc3MiOiJodHRwczovL2F3cy11cy1lYXN0LTItMS5udWNsaWEuY2xvdWQvIiwiaWF0IjoxNzE3NDkxODM4LCJzdWIiOiI5YTgzODA0Yi05NDMyLTQ3ZGEtYjZhZC03NjJkZTQ3MGUxMTIiLCJqdGkiOiJkZDhmYTI1OC1hMTE4LTRlOTEtOGI4Ni0yZWVkYWE2MTNlOTUiLCJleHAiOjE3NDkwMjc4MzcsImtleSI6IjE2MDEzZjdiLWIyYmMtNGI1YS1hNTMwLWM4MzFkNzNmMmUzMiIsImtpZCI6ImEzMTZiMjc4LTRhNGQtNDY5Yy05MjY4LTI2ZGRmMTM1NGMxMiJ9.C5j1mkwO-qNqElnDyypmTB2Mv_9sr0mw6ztGHsowyLyomYMUOf0Mb5bXUD0f4ui8yiMdWtl8rwaTb2CR8ZhNujyhEeCLEUkR16DQ1u1SBy0rCDJi38iiH52F8lF7Ec434OUF0E1k8P5bD7r9T556Osz5Z9hwV9gPeqJC4K0LucI4ys1uxImPG4ln9koKkzYDwFVoKQGD1dETu_Tc0CvqN65oczyIPk40uDywSNlm6zg6YabxJgrPjT5MHUuI8jKIu0P9f2fYcB0A0E1OX3L6RuWVcUJayu1iB_-f5BHez6sTDVwoXdqR13VFvjhDq8nyxE0_0VMeXPvb1EHFKpV3MC5EtMwAl9S-tpsWzHzYQPJFI1irarjvtv6DGbv06Y8_VmjXIFv3gSxymZje_b-IdwmU8AZ-ve0mvd7jne0-1XDi8btyJaRpXqEX--BMOz6y9CJk676PFZqnBbQSsoxKmHUM4RcuHqEs5zYP9l7G39lqNKj8JJtlLf3GEYyTnkkqRlWxhbATMGXgzYJ8il8zhQK8LUMdxXToIvqbs33nhaPBlbdcaPDNnWdqp5NSATA-kvv_x5xmKY7kY93_tuM6PLLSRnZwzM0K6VRAPkp5WFjhZ2uTCj1_OzdBj33YjL3_h6MjdxrJvaiKDCS5Qe01EcSCvD6C9FtR9qlb84VOmeU";

      const endpoint = `https://aws-us-east-2-1.nuclia.cloud/api/v1/kb/d350f202-c79e-4cb4-a64e-f6941e378d99/upload`;

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "X-NUCLIA-SERVICEACCOUNT": `Bearer ${apiKey}`,
            "Content-Type": "application/pdf",
            "x-filename": file.name,
          },
          body: formData,
        });
        const data = await response.json();
        if (data) {
          setResponse(data);
          setFile(null);
          alert.show(`${file.name} Uploaded successfully`, { type: "success" });
        }
      } catch (error) {
        alert.show(error, { type: "error" });
      }
    }
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => {
      const selectedFile = files[0];
      setFile(selectedFile);
      handleSubmit(selectedFile);
    },
  });

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <>
      <Docs resource={props.resource}/>
      <Locations resource={props.resource}/>
    </>
  );
}
export default Results;
